import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class FlowForecastUtilsService {

  monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor() { }

  public floodForecastSelectedRegion: BehaviorSubject<string> = new BehaviorSubject<string>('southZone');
  public floodForecastRfFilterParmas: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public floodForecastSelectedSideBarApplication: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public getFloodForecastSelectedRegion(): Observable<string> {
    return this.floodForecastSelectedRegion.asObservable();
  }

  public getFloodForecastSelectedRegionValue(): string {
    return this.floodForecastSelectedRegion.value;
  }

  public setFloodForecastSelectedRegion(value: string) {
    this.floodForecastSelectedRegion.next(value);
  }

  public getFloodForecastSelectedSideBarApplication(): Observable<string> {
    return this.floodForecastSelectedSideBarApplication.asObservable();
  }

  public setFloodForecastSelectedSideBarApplication(value: string) {
    this.floodForecastSelectedSideBarApplication.next(value);
  }

  public checkUrlParams(obj: object): object {
    const objectConfig = {};
    if (isNullOrUndefined(obj)) {
      return obj;
    }
    for (const key in obj) {
      if (key) {
        objectConfig[key] = obj[key];
      }
    }
    return objectConfig;
  }

  setFloodForecastRfFilterParams(value) {
    this.floodForecastRfFilterParmas.next(value);
  }

  getFloodForecastRfFilterParams() {
    return this.floodForecastRfFilterParmas.asObservable();
  }

  getFloodForecastRfFilterParamsValue() {
    return this.floodForecastRfFilterParmas.value;
  }

  getNDayListInFormat(referenceTS, noOfDays, offset) {
    if (isNullOrUndefined(referenceTS)) {
      referenceTS = new Date().getTime();
    }
    const dayList = [];
    for (let i = offset; i < (noOfDays + offset); i++) {
      let day;
      const currDay = new Date(referenceTS + (i * 24 * 60 * 60 * 1000));
      const date = (currDay.getDate() > 9) ? currDay.getDate() : '0' + currDay.getDate();
      const month = ((currDay.getMonth() + 1) > 9) ? (currDay.getMonth() + 1) : '0' + (currDay.getMonth() + 1);
      const year = currDay.getFullYear();
      day = year.toString() + month.toString() + date.toString();
      dayList.push(day);
    }
    return dayList;
  }

  getReadableDateFromDateString(dateString) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    const date = new Date(year, month - 1, day);
    return day + '-' + this.monthShortLabel[date.getMonth()] + '-' + year;
  }

  getActualHeatMapDateList() {
    let currentDate = new Date();
    currentDate = this.selectDateonBasisOfRFtime(currentDate);
    const startdate = moment(currentDate).format('YYYYMMDD');
    const yesterday = moment(currentDate).subtract(1, 'days').format('YYYYMMDD');
    const dbYesterday = moment(currentDate).subtract(2, 'days').format('YYYYMMDD');
    const dateList = {};
    const set1 = []; set1.push(startdate); set1.push(startdate); // today-today
    const set2 = []; set2.push(yesterday); set2.push(yesterday); // yesterday -yesterday
    const set3 = []; set3.push(dbYesterday); set3.push(dbYesterday); // daybeforeYes - daybeforeYes
    const set4 = []; set4.push(dbYesterday); set4.push(startdate); // last 3 day
    dateList['Today'] = set1;
    dateList['Yesterday'] = set2;
    dateList['Day Before Yesterday'] = set3;
    dateList['Last 3 Day Cummulative'] = set4;
    return dateList;
  }

  getDatesForRainfallActualAndForecastHeatMapsFromApwrims() {
    let currentDate = new Date();
    currentDate = this.selectDateonBasisOfRFtime(currentDate);
    const startDate = moment(currentDate).subtract(3, 'days').format('YYYYMMDD');
    const dateList = [];
    for (let i = 0; i < 10; i++) {
      dateList.push(moment(startDate).add(i, 'days').format('YYYYMMDD'));
    }
    const actualDateList = [];
    for (let i = 0; i <= 3; i++) {
      const curr = moment(startDate).add(i, 'days');
      actualDateList.push({
        value: curr.format('YYYYMMDD'),
        displayName: curr.format('DD-MMM-YYYY')
      });
    }
    const forecastDateList = [];
    for (let i = 3; i < 10; i++) {
      const curr = moment(startDate).add(i, 'days');
      forecastDateList.push({
        value: curr.format('YYYYMMDD'),
        displayName: curr.format('DD-MMM-YYYY')
      });
    }
    const cuurDateInString: Object = moment(currentDate).format('YYYYMMDD');
    return [dateList, actualDateList, forecastDateList, cuurDateInString];
  }

  selectDateonBasisOfRFtime(date) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let todayRFstartTs = currentDate.getTime();
    todayRFstartTs = todayRFstartTs + (8.5 * 3600000);
    const currentTs = new Date().getTime();
    if (currentTs < todayRFstartTs) {
      // subtract one day
      date.setDate(date.getDate() - 1);
    }
    return date;
  }

  createLegend() {
    return new (L as any).Control.HtmlLegend({
      position: 'bottomright',
      collapseSimple: false,
      detectStretched: false,
      collapsedOnInit: false
    });
  }

  getLegendData(data, layerInstance) {
    const legend = {
      name: data.title,
      layer: layerInstance,
    };
    legend['elements'] = [];
    const isTrue = 1;
    if (isTrue == 1 && data.levels.length > 0) {
      let html = ``;
      for (let key = 0; key < data.levels.length; key++) {
        if (data.levels[key].image) {
          html += `<p style='height:30px;margin:0px;padding:4px;color:black;background-color: ${data.levels[key].color}'>
           ${data.levels[key].name} <img src='${data.levels[key].image}'></p>`;
        } else {
          html += `<p style='height:20px;margin:0px;padding:4px;color:black;background-color: ${data.levels[key].color}'>${data.levels[key].name}</p>`;
        }
      }
      legend['elements'].push({ html });
    } else if (data.levels) {
      let obj;
      if (!(data.levels instanceof Array)) {
        const periodWiseLegend = {};
        for (const period in data.levels) {
          if (!isNullOrUndefined(period)) {
            const tempLegend = {
              name: data.title,
              layer: layerInstance,
              elements: []
            };
            data.levels[period].forEach(level => {
              obj = {};
              obj['html'] = '';
              if (level['image'] != undefined && level['image'] != '') {
                obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';
              }
              obj['label'] = level.name;
              obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
              tempLegend.elements.push(obj);
            });
            periodWiseLegend[period] = tempLegend;
          }
        }
        return periodWiseLegend;
      } else {
        data.levels.forEach(level => {
          obj = {};
          obj['html'] = '';
          if (level['image'] != undefined && level['image'] != '') {
            obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';
          }
          obj['label'] = level.name;
          obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
          legend['elements'].push(obj);
        });
      }
    }
    return legend;
  }

  getRangeRainfallLegendData(data, layerInstance) {
    const legend = {};
    legend['name'] = 'Rainfall Level';
    legend['layer'] = layerInstance;
    legend['elements'] = [];
    if (data) {
      let obj;
      let previousLevel = '0.0-';
      let updatedLevel = '0.0';
      let count = 0;
      for (const level in data) {
        if (level) {
          count = count + 1;
          obj = {};
          obj.html = '';
          obj.label = previousLevel + level;
          previousLevel = level + '-';

          if (count == Object.keys(data).length) {
            obj.label = '>= ' + updatedLevel;
            obj.style = {
              'background-color': data[level],
              width: '15px',
              height: '15px'
            };
            legend['elements'].push(obj);
          } else {
            updatedLevel = level;
            obj.style = {
              'background-color': data[level],
              width: '15px',
              height: '15px'
            };
            legend['elements'].push(obj);
          }
        }
      }
    }
    return legend;
  }
}
